module.exports = __webpack_public_path__ + "img/mission-2.c285fa80.png";